import React, { Component } from 'react';
import * as validators from 'utils/validators';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import InputField from 'components/InputField';
import RichField from 'components/RichField';
import ShopifyLocationsSelectField from 'components/ShopifyLocationsField';

class ClientsTableConfiguration extends Component {

    render() {
        let { el, configuration, idx, onClick } = this.props;

        return (<div>
            <h4 style={{ textAlign: "right" }}>#{idx + 1}{" "}<i className="fa fa-times-circle location-panel-remove" title="Remove tablet" onClick={onClick}></i></h4>
            <div className="form-group">
                <label htmlFor={`${el}.apiKey`}>Api Key{' '} </label>

                <Field
                    className="form-control"
                    name={`${el}.apiKey`}
                    component={InputField}
                    type="password"
                    defaultValue = {configuration.subject}
                    validate={[validators.required]}
                />
            </div>
            <div className="form-group">
                <label htmlFor={`${el}.url`}>Tablet Url{' '} </label>

                <Field
                    className="form-control"
                    name={`${el}.url`}
                    component={InputField}
                    type="text"
                    defaultValue = {configuration.subject}
                    validate={[validators.required, validators.url]}
                />
            </div>            
            <div className="form-group">
                <label htmlFor={`${el}.locationId`}>Location</label>
                <Field id={`${el}.locationId`} name={`${el}.locationId`} value={configuration.locationId} component={ShopifyLocationsSelectField} validate={[validators.required]} />
            </div>
        </div>);
    }
}


export default ClientsTableConfiguration;


// WEBPACK FOOTER //
// app/containers/ClientsTableConfiguration.jsx